import type { ComponentProps } from 'react';
import type { Animated, ViewStyle } from 'react-native';
import type { Box } from '../Box';

export interface IOpacity {
  opacity: Animated.Value;
}

export interface IProps extends ComponentProps<typeof Box> {
  withCardContainer?: boolean;
}

export interface IWithType extends IProps {
  type: 'CardAlternativeItem' | 'ProductItem' | 'ProductCart' | 'WrapperItem';
  style?: ViewStyle;
  nItems?: never;
  withFooter?: never;
}

export interface IWithoutType extends IProps {
  type?: never;
  style: ViewStyle;
  nItems?: never;
  withFooter?: never;
}

export interface ICardBasicItem extends IProps {
  type: 'CardBasicItem';
  withFooter?: boolean;
  nItems?: number;
  style?: never;
}

export interface ICardGroup extends IProps {
  type: 'CardGroup';
  style?: never;
  nItems?: number;
  withFooter?: never;
}

export interface IAutoComplete extends IProps {
  type: 'AutoComplete';
  style?: never;
  withFooter?: never;
  nItems?: number;
}

export interface ISearchResult extends IProps {
  type: 'SearchResult';
  style?: never;
  withFooter?: never;
  nItems?: number;
}

export interface IOrderCard extends IProps {
  type: 'OrderCard';
  style?: never;
  withFooter?: never;
  nItems?: number;
}

export type SkeletonType =
  | IWithType
  | IWithoutType
  | ICardBasicItem
  | ICardGroup
  | IAutoComplete
  | ISearchResult
  | IOrderCard;
